export default __webpack_public_path__ + "static/media/Demi 9781408312940.8098323b.jpg";